export const CALCULATIONS_TABLE = {
    'CALCULATIONS.COLUMN.CLIENT_NAME': 'Nume client',
    'CALCULATIONS.COLUMN.COMPANY_NAME': 'Nume companie',
    'CALCULATIONS.COLUMN.YEAR': 'An',
    'CALCULATIONS.COLUMN.QUARTER': 'Trimestru',
    'CALCULATIONS.COLUMN.TAX': 'Impozit',
    'CALCULATIONS.COLUMN.STATEMENT_TYPE': 'Tip declarație',
    'CALCULATIONS.COLUMN.SUBMISSION_DEADLINE': 'Termen depunere',
    'CALCULATIONS.COLUMN.STATUS': 'Status calcul',
    'CALCULATIONS.COLUMN.STATEMENT_STATUS': 'Status declarație',
    'CALCULATIONS.COLUMN.SUBMISSION_DATE': 'Dată depunere',
    'CALCULATIONS.COLUMN.RECEIPT_STATUS': 'Status recipisă',
    'CALCULATIONS.COLUMN.UPDATE_DATE': 'Dată actualizare',
    'CALCULATIONS.COLUMN.STATUS_MODIFIED_DATE': 'Dată actualizare status',
    'CALCULATIONS.COLUMN.UPDATED_BY': 'Actualizat de',
    'CALCULATIONS.ACTION.ADD': 'Calcul nou',
    'CALCULATIONS.ACTION.EDIT': 'Editează',
    'CALCULATIONS.ACTION.SEND_TO_CHECKER': 'Trimite la verificat',
    'CALCULATIONS.ACTION.SEND_TO_APPROVER': 'Trimite la aprobat',
    'CALCULATIONS.ACTION.REJECT': 'Respinge',
    'CALCULATIONS.ACTION.APPROVE': 'Aprobă',
    'CALCULATIONS.ACTION.CLOSE_FOR_SUBMISSION': 'Închide pt. depunere',
    'CALCULATIONS.ACTION.REOPEN': 'Cere redeschidere',
    'CALCULATIONS.ACTION.CONFIRM_SUBMISSION': 'Confirmă depunerea',
    'CALCULATIONS.ACTION.APPROVE_REOPENING': 'Aprobă redeschiderea',
    'CALCULATIONS.ACTION.REJECT_REOPENING': 'Respinge redeschiderea',
    'CALCULATIONS.ACTION.RECALL': 'Recheamă',
    'CALCULATIONS.ACTION.ASSIGN': 'Preia calcul',
    'CALCULATIONS.ACTION.DETAILS': 'Detalii calcul',
    'CALCULATIONS.ACTION.VIEW': 'Vizualizează',
    'CALCULATIONS.ACTION.DELETE': 'Șterge calcul',
    'CALCULATIONS.SEARCH_PLACEHOLDER': 'Caută Client/Companie',
    'CALCULATIONS.FILTER.CALCULATION_PERIOD': 'Perioadă calcul',
    'CALCULATIONS.FILTER.CALCULATION_PERIOD_START': 'De la',
    'CALCULATIONS.FILTER.CALCULATION_PERIOD_END': 'Până la',
    'CALCULATIONS.FILTER.CALCULATION_STATUS': 'Status calcul',
    'CALCULATIONS.FILTER.STATEMENT_TYPE': 'Tip declarație',
    'CALCULATIONS.FILTER.RECEIPT_STATUS': 'Status recipisă',
    'CALCULATIONS.FILTER.STATEMENT_STATUS': 'Status declarație',
    'CALCULATION_LOGS.COLUMN.STATUS': 'Status calcul',
    'CALCULATION_LOGS.COLUMN.TAX': 'Impozit',
    'CALCULATION_LOGS.COLUMN.STATEMENT_STATUS': 'Status declarație',
    'CALCULATION_LOGS.COLUMN.SUBMISSION_DATE': 'Dată depunere',
    'CALCULATION_LOGS.COLUMN.RECEIPT_STATUS': 'Status recipisă',
    'CALCULATION_LOGS.COLUMN.UPDATE_DATE': 'Dată actualizare',
    'CALCULATION_LOGS.COLUMN.REASON': 'Motiv justificativ',
    'CALCULATION_LOGS.COLUMN.UPDATED_BY': 'Actualizat de'
};
